import Highcharts from 'highcharts';
import {
    CHART_COLORS,
    DefaultStatusSvgName,
    StatusToSvgName,
    TimelineAxisTypes,
    TimelineDateSeries,
    TimelineSeriesCustomData,
} from '../../../shared';

function mapMarker(status?: string | null): Pick<Highcharts.PointOptionsObject, 'color' | 'marker'> {
    if (status == null) {
        return {
            marker: {
                symbol: 'circle',
            },
        };
    }

    return {
        color: status === 'Completed' ? CHART_COLORS.COLOUR_PRIMARY : CHART_COLORS.COLOUR_SECONDARY,
        marker: {
            symbol: `url(/highcharts-svg/${StatusToSvgName.get(status.toLowerCase()) ?? DefaultStatusSvgName}.svg)`,
            width: 9,
            height: 9,
        },
    };
}

export type SingleDateSeriesDataItem = {
    label: string;
    value: {
        Start: Date;
        Status?: string | null;
    };
};

type MapSingleDateSeriesOptions = {
    series: TimelineDateSeries;
    /**
     * Gets y offset for data points. Calling it multiple times should result in incrementing values.
     */
    getYOffset: () => number;
};
export function mapSingleDateSeries({
    series,
    getYOffset,
}: MapSingleDateSeriesOptions): Highcharts.SeriesScatterOptions & TimelineSeriesCustomData {
    const y = getYOffset();

    const data: Highcharts.PointOptionsObject[] = (series.data as SingleDateSeriesDataItem[]).map((p) => ({
        ...mapMarker(p.value.Status),
        name: p.label,
        x: new Date(p.value.Start).getTime(),
        y,
        status: p.value.Status,
    }));

    return {
        type: 'scatter',
        data,
        stickyTracking: false,
        custom: {
            axisType: TimelineAxisTypes.Date,
        },
    };
}
